interface Props {
  props: {
    label?: string;
    variant?: 'default' | 'success' | 'warning' | 'danger' | 'info';
  };
}

const MAP: Record<
  NonNullable<Props['props']['variant']>,
  { bg: string; fg: string }
> = {
  default: { bg: 'var(--bg-inset)', fg: 'var(--text-soft)' },
  success: { bg: '#e6f4ec', fg: '#2f855a' },
  warning: { bg: 'var(--accent-bg)', fg: 'var(--accent)' },
  danger: { bg: 'rgba(192,57,43,0.1)', fg: '#c0392b' },
  info: { bg: '#e6f0fb', fg: '#1f6feb' },
};

export function PanelBadge({ props }: Props) {
  const variant = props?.variant ?? 'default';
  const { bg, fg } = MAP[variant];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: bg,
        color: fg,
        padding: '2px 8px',
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: 0.1,
      }}
    >
      {props?.label ?? ''}
    </span>
  );
}
